<div class="sidebar" #sideBar (window:resize)="onResize()">
  <div class="flex justify-between">
    <div class="sidebar-left relative">
      <div class="flex logo" #logo>
        <div class="logo-img">
          <img src="../../../../../assets/img/logo-projects/Logo.png">
        </div>
      </div>
      <div class="menu" [style.max-width]="width+'px'">
        <ul class="overflow-auto" nz-menu nzMode="horizontal" id="style-1" (wheel)="onScroll($event)">
          <ng-container *ngFor="let link of sideBarLinks; let idx = index">
            <li *ngIf="!link.subTabs.length" nz-menu-item [nzSelected]="link.idTab === 'board'" (click)="onOpenTab(link)">
              <div class="menu-name">
                <i nz-icon [nzType]="link.icon" nzTheme="outline"></i>
                {{ link.title }}
              </div>
            </li>
            <li class="title-menu" *ngIf="link.subTabs.length" nz-submenu [nzTitle]="link.title" [nzIcon]="link.icon">
              <ul class="submenu-lv1">
                <ng-container *ngFor="let sub of link.subTabs">
                  <li *ngIf="!sub.subTabs.length" nz-menu-item (click)="onOpenTab(sub)">
                    {{ sub.title }}
                  </li>
                  <li *ngIf="sub.subTabs.length" nz-submenu  [nzTitle]="sub.title">
                    <ul class="submenu-lv2">
                      <ng-container *ngFor="let sub3 of sub.subTabs">
                        <li *ngIf="!sub3.subTabs.length" nz-menu-item (click)="onOpenTab(sub3)">
                          {{ sub3.title }}
                        </li>
                        <li class="title-menu" *ngIf="sub3.subTabs" nz-submenu  [nzTitle]="sub3.title">
                          <ul>
                            <ng-container *ngFor="let sub4 of sub.subTabs">
                              <li nz-menu-item (click)="onOpenTab(sub4)">
                                {{ sub4.title }}
                              </li>
                            </ng-container>
                          </ul>
                        </li>
                      </ng-container>
                    </ul>
                  </li>
                </ng-container>
              </ul>
            </li>
          </ng-container>
          <!-- <li class="menu-name" nz-menu-item (click)="onOpenMail()">
            <i nz-icon [nzType]="'mail'" nzTheme="outline"></i>
            Hộp thư
          </li> -->
        </ul>
      </div>
    </div>
    <div class="sidebar-right flex" #userMenu>
      <div class="flex items-center">
        <!-- <div class="flex item-option">
          <app-menu-option [trigger]="'click'" [tooltipTrigger]="'hover'"></app-menu-option>
        </div> -->
        <div class="user-menu">
          <ul nz-menu nzMode="horizontal" class="flex">
            <li nz-menu-item nz-dropdown [nzTrigger]="'click'" [nzDropdownMenu]="menuUser"
              [nzPlacement]="'bottomRight'">
              <nz-avatar nzIcon="user" [nzSrc]="userInfo.avatar"></nz-avatar>
              <span>
                {{userInfo.fullName}}
              </span>
            </li>
            <li nz-menu-item #elItem style="margin: 0 !important;">
            </li>
          </ul>
          <nz-dropdown-menu #menuUser="nzDropdownMenu">
            <ul nz-menu nzSelectable>
              <li nz-menu-item *ngFor="let item of userItems" (click)="item.handler()"><i nz-icon [nzType]="item.icon"
                  nzTheme="outline"></i>{{ item.tooltip }}</li>
              <hr>
              <li nz-menu-item (click)="logout()"><i nz-icon nzType="logout" nzTheme="outline"></i>Đăng xuất</li>
            </ul>
          </nz-dropdown-menu>
        </div>
      </div>
    </div>
  </div>
</div>
